<template>
    <div style="background:rgba(139,139,139, 0.03); border-radius: 10px; position: absolute; left: 0; bottom: 0; right: 0; top: 0; z-index: 10"/>
</template>

<script>
    export default {
        name: "disabled"
    };
</script>
